import { PropsWithChildren } from 'react'

import styles from './wrapper.module.scss'

const Wrapper = ({ children }: PropsWithChildren) => {
  return <div className={styles.wrapperContent}>{children && children}</div>
}

export default Wrapper
